import { render, staticRenderFns } from "./CollateralPositionsList.vue?vue&type=template&id=31aceb38&"
import script from "./CollateralPositionsList.vue?vue&type=script&lang=js&"
export * from "./CollateralPositionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports